import React from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {useTranslation} from 'react-i18next';
import Separator from '../../../../../components/Simple/Sepperator';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import SMCTextArea from '../../../../../components/Simple/SMCTextArea';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.cliScriptFromApi;

function BaseCliScriptFromApi({
    pageData
}) {
    const { t } = useTranslation();

    const script = pageData[pageSchema.script];

    return (
        <EditorLayout>
            <SMCToggleSwitch disabled checked={false} label={t('SMP.PLAN.MANAGE_IN_SMP')} />
            <Separator isMainSeparator/>
            {/* CLI script */}
            <SMCLabel>{t('SMP.GATEWAYS.PAGE.CLI_SCRIPTS.ENTER_A_CLI_SCRIPT')}</SMCLabel>
            <SMCTextArea
                disabled={true}
                value={script}
                width="580px"
                height="140px"
                style={{ fontFamily: 'monospace' }}
            />
            <SMCLabel>{t('SMP.GATEWAYS.PAGE.CLI_SCRIPTS.NOTE_REMOTE_CLI_SCRIPT')}</SMCLabel>
        </EditorLayout>
    );
}

export default BaseCliScriptFromApi;